import React from 'react';
import { Form, Input, Button, Select, Typography } from 'antd';

const { Title, Paragraph } = Typography;


const Step4 = ({ form, next, prev }) => {
  return (
    <div>

      <Title level={2}>Emergency Contact Details</Title>
      <Form form={form} layout="vertical" onFinish={next}>
        <Form.Item name="emergencyContactName" label="Emergency Contact Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="emergencyContactNumber" label="Emergency Contact Number" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="emergencyContactRelation" label="Emergency Contact Relation" rules={[{ required: true }]}>
          <Select>
            <Select.Option value="parent">Parents</Select.Option>
            <Select.Option value="child">Child</Select.Option>
            <Select.Option value="partner">Partner</Select.Option>
            <Select.Option value="other">Other</Select.Option>
          </Select>
        </Form.Item>
        <Button style={{ marginRight: 20 }} type="primary" onClick={prev}>Back</Button>
        <Button type="primary" htmlType="submit">Next</Button>
      </Form>
    </div>
  );
};

export default Step4;
